import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import OrganizationInviteVerification from 'src/assets/images/OrganizationInviteVerification.svg'
import AppName from 'src/components/AppName/AppName'
import Button, {
  ButtonDesigns,
  ButtonTypes,
} from 'src/components/Button/Button'
import Trns from 'src/localization/Trns'
import { OrganizationsListResponse } from 'src/models/organizations.models'
import { peopleMembersUrl } from 'src/navigation/urls'
import { css } from 'styled-components'

interface AcceptOrgInvitationConfirmationProps {
  organization: OrganizationsListResponse
}

const AcceptOrgInvitationConfirmation: React.FC<
  AcceptOrgInvitationConfirmationProps
> = ({ organization }) => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 40px;
      `}
    >
      <img src={OrganizationInviteVerification} alt="" />
      <div
        css={css`
          display: flex;
          margin-top: 30px;
          margin-bottom: 20px;
          flex-direction: column;
          align-items: center;
          text-align: center;
        `}
      >
        <p
          css={css`
            ${getFontCss(
              20,
              styleConstants.colors.black,
              styleConstants.fontFamilies.medium,
            )}
          `}
          id={'orgJoined'}
        >
          <Trns
            source={"You've joined ${orgName}!"}
            expressions={{
              orgName: (
                <span
                  css={css`
                    ${getFontCss(
                      20,
                      themeConstants.colors.highlight,
                      styleConstants.fontFamilies.medium,
                    )}
                  `}
                >
                  {organization.name}
                </span>
              ),
            }}
          />
        </p>
        <p
          css={css`
            margin-bottom: 40px;
            margin-top: 20px;
            ${getFontCss(
              16,
              styleConstants.colors.black,
              styleConstants.fontFamilies.regular,
            )}
          `}
        >
          <Trns
            source={
              "Now that you're a part of an organization, you can view the other members and see how they're using ${appName}."
            }
            expressions={{
              appName: <AppName />,
            }}
          />
        </p>
        <Button
          id={'viewOrganizationMembers'}
          type={ButtonTypes.button}
          design={ButtonDesigns.designCta}
          big
          text={<Trns source={'View your Organization Members'} />}
          linkProps={{
            to: peopleMembersUrl(),
            ariaLabelSource: 'View your Organization Members',
          }}
          css={css`
            width: 300px;
          `}
        />
      </div>
    </div>
  )
}

export default AcceptOrgInvitationConfirmation
